import {
    Dialog,
    DialogContent,
    DialogTitle,
    LinearProgress,
    Typography,
} from "@mui/material"

function ModalLoading({ open }) {
    return (
        <Dialog open={open}>
            <DialogTitle align="center">Carregando</DialogTitle>
            <DialogContent>
                <Typography align="center">
                    Não feche a janela, nem recarregue
                </Typography>

                <LinearProgress sx={{ mt: 4, mb: 4 }} />
            </DialogContent>
        </Dialog>
    )
}

export default ModalLoading
